export const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export function formatDateToString(data: Date): string {
  const date = new Date(data);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  return `${day}/${month}/${year} ${hours}:${minutes}`;
}

export function toDateFormatted(data: Date): string {
  const date = new Date(data);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
}

// return "1 Jan 2024"
export function toDateMonthYear(data: Date): string {
  const date = new Date(data);
  const day = date.getDate();
  const month = months[date.getMonth()].slice(0, 3); // Get the first 3 letters of the month
  const year = date.getFullYear();
  return `${day} ${month} ${year}`;
}

export function formatDateLocale(data: Date): string {
  const date = new Date(data);
  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}

export function calculateDaysOfLeave(
  startDate: Date,
  startDateIsAm: boolean,
  endDate: Date,
  endDateIsAm: boolean
): number {
  console.log(startDate, startDateIsAm, endDate, endDateIsAm);

  const startDateOnly = new Date(startDate.toDateString());
  const endDateOnly = new Date(endDate.toDateString());

  // If startDate and endDate are the same
  if (startDateOnly.getTime() === endDateOnly.getTime()) {
    if (startDateIsAm && endDateIsAm) {
      return 0.5; // Both AM, so half a day
    } else if (startDateIsAm || !endDateIsAm) {
      return 1; // Start AM and End PM (or similar), so full day
    } else {
      return 0.5; // Both PM, so half a day
    }
  }

  // Calculate the full days between the two dates
  const fullDays =
    (endDateOnly.getTime() - startDateOnly.getTime()) / (1000 * 60 * 60 * 24);

  // Adjust for AM/PM
  let adjustedDays = fullDays;
  if (startDateIsAm) {
    adjustedDays += 0.5; // Start in the AM, so add 0.5 day
  }
  if (!endDateIsAm) {
    adjustedDays += 0.5; // End in the PM, so add 0.5 day
  }

  return adjustedDays;
}

export function getYears(): number[] {
  const fromYear = 2024;
  const currentYear = new Date().getFullYear();
  return Array.from(
    { length: currentYear - fromYear + 1 },
    (_, i) => fromYear + i
  );
}
export function getUTCDate(date: Date): Date {
  return new Date(
    Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
  );
}

export function getYearBeforeCurrent(): number[] {
  const currentYear = new Date().getFullYear();
  // arrange descending order

  const res = Array.from({ length: 2 }, (_, i) => currentYear - i);
  return res;
}
